module.exports = __webpack_public_path__ + "static/img/yk6220.a938d73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk6220.png
// module id = 4P4j
// module chunks = 1